import { Facebook } from '@ionic-native/facebook/ngx';
import { EnvService } from './env.service';
import * as i0 from "@angular/core";
import * as i1 from "@ionic-native/facebook/ngx/index";
import * as i2 from "./env.service";
export class ShareService {
    constructor(fb, envService) {
        this.fb = fb;
        this.envService = envService;
        this.baseURL = envService.BASE_URL;
    }
    replaceUrl(url) {
        const route = url.substring(url.indexOf('#') + 1);
        return this.baseURL + route;
    }
    shareToFacebook(url) {
        this.replaceUrl(url);
        const options = {
            method: 'share',
            href: url,
            caption: '',
            description: '',
            picture: '',
            hashtag: '',
            fallback_redirect_uri: url,
            share_feedWeb: true,
        };
        this.fb.showDialog(options)
            .then(res => {
            console.log(res, 'shared fb object');
        })
            .catch(e => console.log('Error logging into Facebook', e));
    }
    shareToTwitter(url) {
        const tweetUrl = url.replace('#', '%23');
        return 'https://twitter.com/intent/tweet?' + 'url=' + tweetUrl + '&text=' + 'Promoga Promotion';
    }
    shareToEmail(url) {
        return url;
    }
}
ShareService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ShareService_Factory() { return new ShareService(i0.ɵɵinject(i1.Facebook), i0.ɵɵinject(i2.EnvService)); }, token: ShareService, providedIn: "root" });
